// Radius-only auth helpers (kept separate from your SysAdmin auth)
export const RADIUS_TOKEN_KEY = 'radius_jwt';

export function getRadiusToken() {
  return localStorage.getItem(RADIUS_TOKEN_KEY);
}

export function isRadiusLoggedIn() {
  return !!getRadiusToken();
}

export function logoutRadius() {
  localStorage.removeItem(RADIUS_TOKEN_KEY);
  localStorage.removeItem('radius_user');
  localStorage.removeItem('radius_user_type');
  localStorage.removeItem('radius_permissions');
}

export function radiusAuthHeader() {
  const token = getRadiusToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
